import { RegItem } from 'src/types/regItem'
import { Offer } from 'src/types/offer'

export const findBabylistOfferFor = (regItem: RegItem): Offer | undefined =>
  regItem.offers.find((o) => o.isBabylist)
